import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "report-notes-modal",
  "data-backdrop": "static",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "report-notes-modal-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "report-notes-modal-title"
  }, " Notes "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Check In report date and cleaning status at the beginning of tenancy", -1)
const _hoisted_8 = { class: "col-sm-9" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "General notes", -1)
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary mr-auto",
    "data-dismiss": "modal"
  }, " Cancel "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary",
    "data-dismiss": "modal"
  }, "Ok")
], -1)

import { computed, ref } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportNotesModal',
  setup(__props) {

const store = useStore();

const report = computed(() => store.getters['reports/current']);

const setReportDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload);
};

const generalNotes = computed({
  get: () => report.value.propertyDetails.generalNotes,
  set: (data: string) => {
    setReportDeep({ path: 'propertyDetails.generalNotes', data });
  },
});

// Computed property for historical_cleaning_status
const historicalCleaningStatus = computed({
  get: () => report.value.propertyDetails.historicalCleaningStatus,
  set: (data) => setReportDeep({ path: 'propertyDetails.historicalCleaningStatus', data })
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("fieldset", null, [
            (report.value.type === 'checkout')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control",
                      rows: "5",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((historicalCleaningStatus).value = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        historicalCleaningStatus.value,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  rows: "20",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((generalNotes).value = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    generalNotes.value,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ])
            ])
          ])
        ]),
        _hoisted_12
      ])
    ])
  ]))
}
}

})